import withQuery from 'with-query';
import { SGBC_API_ROOT, SGBC_API_CORS_ROOT } from 'config.js';
import fetchlib from 'js/fetchlib';

export function staffCertApplBuildingTypesGetInfo(certificateId) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/certificates_v1/cn/certificate-building-type-options`, {
            action: 'get-all-by-certificate-id',
            certificateId,
        });
        return fetchlib.fetch(dispatch, getState, 'POST', url, null, null, null, null);
    };
}
export function staffCertApplBuildingTypesGetDropdownOptions() {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/certificates_v1/cn/building-type-option`, {
            action: 'get-all-active',
        });
        return fetchlib.fetch(dispatch, getState, 'POST', url, null, null, null, null);
    };
}
export function staffCertApplBuildingTypesSaveOptions(certificateId, options) {
    return (dispatch, getState) => {
        const url = withQuery(`${SGBC_API_CORS_ROOT}/certificates_v1/cn/building-type-option`, {
            action: 'update-by-certificate-id',
        });
        const body = { certificateId, options };
        return fetchlib.fetch(dispatch, getState, 'POST', url, body, null, null, null, null);
    };
}
